"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var three_sixty_rater_display_logic_modal_html_1 = __importDefault(require("./three-sixty-rater-display-logic-modal.html"));
(function (module) {
    'use strict';
    module.factory('prRaterDisplayLogicModal', [
        'qstrap.modal',
        function (modal) {
            function show() {
                return modal({
                    templateUrl: three_sixty_rater_display_logic_modal_html_1.default,
                    controller: 'prRaterDisplayLogicModalController',
                    show: true
                });
            }
            return {
                show: show
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
